<div class="switch-layout"
     [style.--selector-active-color]="colorSelectorActivo">
    <div  class="main-title-right-new"
          [ngClass]="active ? 'main-title-right-active' :''">
        <svg [ngClass]="{'icon':true, 'hide':!iconoOpcion1}" >
            <use [attr.xlink:href]="iconoOpcion1|iconoRef"></use>
          </svg>
        <span [ngClass]="active ? 'main-title-right-active' :''">{{textoOpcion1}}</span>
    </div>
    <label class="buttonSwitch">
        <input type="checkbox" (click)="click()" [checked]="active">
        <span class="slider" [ngClass]="{'slider': true, 'slider-sandbox': textoOpcion2=='Sandbox' || textoOpcion1=='SANDBOX'}" ></span>
    </label>
    <div class="main-title-right-new"
         [ngClass]="active ? 'main-title-right-active' :''">
        <svg [ngClass]="{'icon':true, 'hide':!iconoOpcion2}" >
            <use [attr.xlink:href]="iconoOpcion2|iconoRef"></use>
          </svg>
        <span [ngClass]="{'main-title-right-active': active, 'main-title-right-active-background': active && backgroundActive}">{{textoOpcion2}}</span>
    </div>
</div>
